/** Streak over consecutive local-day daily wins (spec §3.4). */
export interface StreakState {
  currentStreak: number;
  maxStreak: number;
  lastWinDayNumber: number | null;
}

export const EMPTY_STREAK: StreakState = Object.freeze({
  currentStreak: 0,
  maxStreak: 0,
  lastWinDayNumber: null,
});

/** Pure streak transition for a finished daily game. */
export function applyDailyOutcome(
  s: StreakState,
  dayNumber: number,
  won: boolean,
): StreakState {
  if (!won) return { ...s, currentStreak: 0 };
  if (dayNumber === s.lastWinDayNumber) return s;
  const consecutive = s.lastWinDayNumber !== null && dayNumber === s.lastWinDayNumber + 1
    && s.currentStreak > 0;
  const currentStreak = consecutive ? s.currentStreak + 1 : 1;
  return {
    currentStreak,
    maxStreak: Math.max(s.maxStreak, currentStreak),
    lastWinDayNumber: dayNumber,
  };
}
